var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "sc-filters",
    },
    [
      _vm.filters
        ? _c("pui-filter", {
            attrs: {
              "use-router": false,
              config: _vm.filterConfiguration,
              "vuex-namespace": _vm.namespace,
            },
            on: {
              "changed:applied-values": _vm.filtersChanged,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }